// !!! THIS FILE IS GENERATED BY codegen.js !!!

import { css, SerializedStyles } from '@emotion/core'

export const xsmall = (strings: TemplateStringsArray, ...args: Array<any>): SerializedStyles => {
  return css`
    @media only screen and (min-width: 0px) {
      ${css(strings, ...args)}
    }
  `
}

export const xsmallOnly = (strings: TemplateStringsArray, ...args: Array<any>): SerializedStyles => {
  return css`
    @media only screen and (min-width: 0px) and (max-width: 710px) {
      ${css(strings, ...args)}
    }
  `
}

export const small = (strings: TemplateStringsArray, ...args: Array<any>): SerializedStyles => {
  return css`
    @media only screen and (min-width: 711px) {
      ${css(strings, ...args)}
    }
  `
}

export const smallDown = (strings: TemplateStringsArray, ...args: Array<any>): SerializedStyles => {
  return css`
    @media only screen and (max-width: 710px) {
      ${css(strings, ...args)}
    }
  `
}

export const smallOnly = (strings: TemplateStringsArray, ...args: Array<any>): SerializedStyles => {
  return css`
    @media only screen and (min-width: 711px) and (max-width: 1071px) {
      ${css(strings, ...args)}
    }
  `
}

export const medium = (strings: TemplateStringsArray, ...args: Array<any>): SerializedStyles => {
  return css`
    @media only screen and (min-width: 1072px) {
      ${css(strings, ...args)}
    }
  `
}

export const mediumDown = (strings: TemplateStringsArray, ...args: Array<any>): SerializedStyles => {
  return css`
    @media only screen and (max-width: 1071px) {
      ${css(strings, ...args)}
    }
  `
}

export const mediumOnly = (strings: TemplateStringsArray, ...args: Array<any>): SerializedStyles => {
  return css`
    @media only screen and (min-width: 1072px) and (max-width: 1679px) {
      ${css(strings, ...args)}
    }
  `
}

export const large = (strings: TemplateStringsArray, ...args: Array<any>): SerializedStyles => {
  return css`
    @media only screen and (min-width: 1680px) {
      ${css(strings, ...args)}
    }
  `
}
